@if(matchStatsService.isLoadingMatchStats()) {
<app-skeleton-match-stats />
} @if(!matchStatsService.isLoadingMatchStats() && matchStatsService.matchStats()
!== null && matchStatsService.matchStats().Stats.length > 0){
<div class="flex flex-col gap-4">
  @for (matchStats of this.liveMatchStats().Stats; track $index) {
  <app-stats-indicator [data]="matchStats" />
  }
</div>
} @if(!matchStatsService.isLoadingMatchStats() &&
(matchStatsService.matchStats() === null ||
matchStatsService.matchStats().Stats.length == 0)) {
<div
  class="font-roboto-700 text-blue-o-50 bg-white my-4 p-4 max-sm:p-3 rounded-6 text-center max-sm:my-2"
>
  {{ "NotAvalaibleInformation" | translate }}
</div>
}
